export default "__VITE_ASSET__4FjeARC7__"